import InternalControlLayout from './InternalControlLayout';

export default InternalControlLayout;
